import { SocketMiddlewareService } from '@service/socket-middleware.service';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { PermissionGuardService } from './permission-guard.service';
import { VesselEditGuardService } from './vessel-edit-guard.service';

@Injectable({ providedIn: 'root' })
export class HttpInterceptorService implements HttpInterceptor {
    constructor(
        private permissionGuardService: PermissionGuardService,
        private socketMiddlewareService: SocketMiddlewareService,
        private vesselEditGuardService: VesselEditGuardService,
        private router: Router
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): any {
        const socket = this.socketMiddlewareService.getSocket();
        const socketId = socket?.id;
        const modifiedReq = req.clone({
            withCredentials: true,
            headers: req.headers.set('x-socket-id', socketId ?? ''),
        });
        const hasPermission = this.permissionGuardService.checkPermission(req);
        const canEditVessel = this.vesselEditGuardService.canEdit(req);
        if (!hasPermission || !canEditVessel) {
            this.permissionGuardService.showPermissionDeniedDialog();
            return throwError(() => this.permissionGuardService.permissionError);
        }
        return next.handle(modifiedReq).pipe(
            catchError((error: HttpErrorResponse) => {
                const url = error.error?.url;
                if (req.url === '/auth/check') {
                    if (error.error.oid) {
                        return this.router.navigate(['/iCreateLogin'], {
                            state: { unauthorized: true },
                        });
                    }
                    return this.router.navigate(['/iCreateLogin'], {
                        state: { unauthorized: false, url: url },
                    });
                } else if (error.status === HttpStatusCode.Unauthorized || error.status === 498) {
                    return this.router.navigate(['/iCreateLogin'], {
                        state: { unauthorized: false, url: url },
                    });
                }
                return throwError(() => error);
            })
        );
    }
}
